import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
  memo,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import { createPortal } from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import ReactModal from "react-modal";
import Iframe from "react-iframe";
import {
  apiError,
  setActiveFooterTab,
  setActiveTab,
  showSideBar,
} from "../../store/actions";
import Hamburger from "./Hamburger";
import { loginUser, logoutUser } from "../../store/Auth/actions";
import { withRouter } from "react-router-dom";
import { getUserBalance } from "./Utils/helpers";
import {
  axiosApi,
  BlockedGames,
  getLiveSportsCall,
  getSlotegratorGameCall,
} from "../../helpers/repository";
import { currency } from "../../helpers/constants";
import brand from "../../brand.config";
import { getUrlLastPart } from "./Utils/helpers";
import PopularSports from "./PopularSports";
import Layout from "../Layouts/Layout";
import debounce from "debounce";
import toastr from "toastr";
import HeaderNav from "./HeaderNav";
import Banners from "./Banners";
import {
  CreditCard,
  Eye,
  EyeOff,
  Gem,
  Gift,
  History,
  LogOut,
  Plus,
  RefreshCwIcon,
  User,
} from "lucide-react";
import { SPORT_IDS } from "../../helpers/sports";
import { Button } from "../ui/button";
import { IconButton } from "../ui/icon-button";
import { AccountMenu } from "../ui/account-menu";
import { Badge } from "../ui/badge";
import { Tag } from "../ui/tag";
import { Calendar, X, ArrowRight } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";

const MemoizedHeaderNav = memo(HeaderNav);
const MemoizedPopularSports = memo(PopularSports);

export const NairaIcon = () => (
  <svg
    fill="#656565"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="16"
    height="16"
    viewBox="0 0 496.262 496.262"
    xmlSpace="preserve"
  >
    <g>
      <path d="M477.832,274.28h-67.743v-65.106h67.743c10.179,0,18.43-8.243,18.43-18.424c0-10.182-8.251-18.43-18.43-18.43h-67.743 V81.982c0-13.187-2.606-22.866-7.743-28.762c-4.882-5.609-11.301-8.219-20.19-8.219c-8.482,0-14.659,2.592-19.447,8.166 c-5.077,5.902-7.654,15.599-7.654,28.821v90.343H227.627l-54.181-81.988c-4.637-7.317-8.997-14.171-13.231-20.75 c-3.812-5.925-7.53-10.749-11.042-14.351c-3.109-3.189-6.652-5.657-10.796-7.554c-3.91-1.785-8.881-2.681-14.762-2.681 c-7.501,0-14.31,2.055-20.83,6.277c-6.452,4.176-10.912,9.339-13.636,15.785c-2.391,6.126-3.656,15.513-3.656,27.63v77.626h-67.07 C8.246,172.326,0,180.574,0,190.755c0,10.181,8.246,18.424,18.424,18.424h67.07v65.113h-67.07C8.246,274.292,0,282.538,0,292.722 C0,302.9,8.246,311.14,18.424,311.14h67.07v103.143c0,12.797,2.689,22.378,8.015,28.466c5.065,5.805,11.487,8.5,20.208,8.5 c8.414,0,14.786-2.707,20.07-8.523c5.411-5.958,8.148-15.533,8.148-28.442V311.14h115.308l62.399,95.683 c4.339,6.325,8.819,12.709,13.287,18.969c4.031,5.621,8.429,10.574,13.069,14.711c4.179,3.742,8.659,6.484,13.316,8.157 c4.794,1.726,10.397,2.601,16.615,2.601c16.875,0,34.158-5.166,34.158-43.479V311.14h67.743c10.179,0,18.43-8.252,18.43-18.43 C496.262,282.532,488.011,274.28,477.832,274.28z M355.054,209.173v65.106h-60.041l-43.021-65.106H355.054z M141.936,134.364 l24.76,37.956h-24.76V134.364z M141.936,274.28v-65.106h48.802l42.466,65.106H141.936z M355.054,365.153l-35.683-54.013h35.683 V365.153z"></path>
    </g>
  </svg>
);

function Header(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoggedIn = sessionStorage.getItem("token") ? true : false;
  const [, setShow] = useState(false);
  const Sports = useSelector((state) => state?.Sports.Index ?? []);
  const Banner = useSelector((state) =>
    state?.Banner?.Index.filter(
      (banner) => banner["page_name"] === "Home Page",
    ),
  );

  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [iframeURL, setIframeURL] = useState(null);
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  const Products = useSelector((state) => state?.Products.Index ?? []);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "67%",
      overflow: "hidden",
      padding: "20px",
      borderRadius: "16px",
    },
  };

  const dateModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1100,
    },
    content: {
      position: "absolute",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxWidth: "400px",
      backgroundColor: "#1b1c20",
      border: "1px solid #252838",
      borderRadius: "12px",
      padding: "20px",
      overflow: "visible",
      outline: "none",
    },
  };

  const handleLogout = (e) => {
    e.preventDefault();
    const { history } = props;
    dispatch(logoutUser(history));
  };

  useEffect(() => {
    BlockedGames()
      .then((res) => {
        setIframeURL(res);
      })
      .catch((e) => {
        if (e?.response?.data?.code == "restrict") {
          setShow(true);
          // props.history.push("/comming-soon");
        }
      });
  }, []);

  const active_tab = useSelector(
    (state) => state?.CommonState?.activeTab ?? "home-upcoming",
  );

  const formErrors = useSelector((state) => state?.CommonState.apiError || {});

  let path = props?.location?.pathname.substring(1);

  const removeError = (key) => {
    let e = _.cloneDeep(formErrors);
    delete e[key];
    dispatch(apiError(e));
  };

  let dataMenu = useMemo(
    () => ({
      Sports: {
        className: `${["home-upcoming", "home-live-now"].includes(active_tab ?? "")
            ? "active"
            : ""
          }`,
        route: () => props.history.push("/sports"),
        dispatch: () => dispatch(setActiveTab("home-upcoming")),
        footerActive: "",
        icon: "/assets/images/SVG/sport.svg",
      },
      AllSports: {
        className: `${["AllSports", "sports-details", "Football"].includes(active_tab)
            ? "active"
            : ""
          }`,
        route: () => props.history.push("/AllSports"),
        dispatch: () => dispatch(setActiveTab("AllSports")),
        footerActive: "",
        icon: "/assets/images/SVG/gamepad.svg",
      },
      Aviator: {
        className: `${["Aviator", "aviator"].includes(active_tab ?? "") ? "active" : ""
          }`,
        route: () => props.history.push("/aviator"),
        dispatch: () => dispatch(setActiveFooterTab("")),
        footerActive: "",
        icon: "/assets/images/SVG/avaition.svg",
      },
      Jackpot: {
        className: `${["jackpot", "jackpot-running", "jackpot-upcoming"].includes(
          active_tab ?? "",
        )
            ? "active"
            : ""
          }`,
        route: () => props.history.push("/jackpot"),
        dispatch: () => dispatch(setActiveTab("jackpot")),
        footerActive: () => setActiveFooterTab(""),
        icon: "/assets/images/SVG/avaition.svg",
      },
      Virtuals: {
        className: `${getUrlLastPart() == "virtual-league" ? "active" : ""}`,
        route: () => props.history.push("/virtual-league"),
        dispatch: () => dispatch(setActiveTab("virtual-league")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        icon: "/assets/images/SVG/virtual.svg",
      },
      Games: {
        className: `${active_tab == "Games" ? "active" : ""}`,
        route: () => props.history.push("/games"),
        dispatch: () => dispatch(setActiveTab("Games")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        // badge: "NEW",
        icon: "/assets/images/SVG/gamepad.svg",
      },
      Slot: {
        className: `${active_tab == "slot" ? "active" : ""}`,
        route: () => props.history.push("/slot"),
        dispatch: () => dispatch(setActiveTab("slot")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        // badge: "NEW",
        icon: "/assets/images/SVG/gamepad.svg",
      },
      BigBoom: {
        className: `${active_tab == "booming" ? "active" : ""}`,
        route: () => props.history.push("/booming"),
        dispatch: () => dispatch(setActiveTab("booming")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        // badge: "NEW",
        icon: "/assets/images/SVG/gamepad.svg",
      },
      Spribe: {
        className: `${active_tab == "Spribe" ? "active" : ""}`,
        route: () => props.history.push("/Spribe"),
        dispatch: () => dispatch(setActiveTab("Spribe")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        icon: "/assets/images/SVG/sport.svg",
      },
      LiveCasino: {
        className: `${active_tab == "LiveCasino" ? "active" : ""}`,
        route: () => props.history.push("/provider/23"),
        dispatch: () => dispatch(setActiveTab("LiveCasino")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        // badge: "NEW", // desktop nav intentionally has no badge; mobile shows one — see HeaderNav.jsx
        icon: "/assets/images/SVG/medal.svg",
      },
      // HotGames: {
      //   className: `${active_tab == "HotGames" ? "active" : ""}`,
      //   route: () => props.history.push("/hot-games"),
      //   dispatch: () => dispatch(setActiveTab("HotGames")),
      //   footerActive: () => dispatch(setActiveFooterTab("")),
      //   badge: "NEW",
      //   icon: "/assets/images/SVG/medal.svg",
      // },

      Promotions: {
        className: `${active_tab == "promotions" ? "active" : ""}`,
        route: () => props.history.push("/promotions"),
        dispatch: () => dispatch(setActiveTab("promotions")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        icon: "/assets/images/SVG/promotion.svg",
      },
      ClubHouse: {
        className: `${active_tab == "casinos" ? "active" : ""}`,
        route: () => props.history.push("/casinos"),
        dispatch: () => dispatch(setActiveTab("casinos")),
        footerActive: () => dispatch(setActiveFooterTab("")),
        icon: "/assets/images/SVG/club.svg",
      },
    }),
    [active_tab, dispatch, props.history],
  );
  const excludedPaths = ["/login", "/register", "/forgot-pin"];
  const isPathExcluded = excludedPaths.includes(props.location.pathname);
  useEffect(() => {
    if (!Object.keys(formErrors).length) return;
    if (formErrors) {
      Object.keys(formErrors).map((key) => {
        if (formErrors[key][0] && formErrors[key][0].length > 5) {
          toastr.error(formErrors[key][0]);
        }
      });
      dispatch(apiError({}));
    }
  }, [formErrors]);

  const [showBalance, setShowBalance] = useState(true);
  const toggleBalance = () => {
    setShowBalance((prev) => !prev);
  };
  // Sub-bar day filter. Design's onDayFilter (index.html App shell) both sets
  // the active tag AND navigates to a filtered fixtures view (FixturesPage) —
  // clicking Today/Tomorrow/Weekend is the same kind of "drill into filtered
  // results" interaction as clicking a league chip (which navigates to
  // CompetitionPage). Both land on the same real route in this app,
  // /league-details: a specific league (?id=<bb_id>) renders the single-league
  // date-grouped view, no id + a day param renders the cross-competition
  // FixturesPage-style view for that day. Kept in sync FROM the URL too, so
  // the Tag reflects whatever day filter is actually applied if the user
  // navigates directly (e.g. browser back/forward).
  const [dayFilter, setDayFilter] = useState(null);
  useEffect(() => {
    const urlParams = new URLSearchParams(props.location.search);
    if (props.location.pathname === "/sport" && urlParams.get("date") === "custom") {
      setDayFilter("custom");
      return;
    }
    if (props.location.pathname !== "/league-details" || urlParams.get("id")) {
      setDayFilter(null);
      return;
    }
    const urlDay = urlParams.get("day");
    setDayFilter(["today", "tomorrow", "weekend"].includes(urlDay) ? urlDay : null);
  }, [props.location.pathname, props.location.search]);

  const handleDayFilterClick = (id) => {
    const nextDay = dayFilter === id ? null : id;
    const currentSportId = new URLSearchParams(props.location.search).get("id") || "1";
    const searchParams = new URLSearchParams();
    searchParams.set("sport_id", currentSportId);
    if (nextDay) searchParams.set("day", nextDay);
    props.history.push(`/league-details?${searchParams.toString()}`);
  };

  const toLocalISOString = (d) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.000Z`;
  };

  const handleApplyDates = () => {
    if (!tempStartDate || !tempEndDate) {
      toastr.error(
        t("header_date_range_required", "Please select both start and end dates"),
      );
      return;
    }
    const startObj = new Date(tempStartDate + "T00:00:00");
    const endObj = new Date(tempEndDate + "T23:59:59");
    if (startObj > endObj) {
      toastr.error(
        t("header_date_range_invalid", "Start date cannot be after end date"),
      );
      return;
    }
    
    const startISO = toLocalISOString(startObj);
    const endISO = toLocalISOString(endObj);
    const sportId = getActiveSportId();
    
    setIsDateModalOpen(false);
    props.history.push(`/sport?id=${sportId}&date=custom&start_date=${startISO}&end_date=${endISO}`);
  };

  const handleClearDates = () => {
    setTempStartDate("");
    setTempEndDate("");
  };

  const getActiveSportId = () => {
    const urlParams = new URLSearchParams(props.location.search);
    if (props.location.pathname === "/sports-details") {
      return urlParams.get("id") || "1";
    }
    if (props.location.pathname === "/league-details") {
      return urlParams.get("sport_id") || "1";
    }
    if (props.location.pathname === "/sport") {
      return urlParams.get("id") || "1";
    }
    return "1";
  };

  // Design's TopBar (Shell.jsx) renders this sub-bar unconditionally on every
  // page, not just the sports home — extend it to the sport-browsing routes
  // (sports-details/league-details use the same FootballLanding-equivalent
  // layout in the design). Other routes (wallet, account, etc.) keep it hidden.
  const showSportsSubbar =
    props.location.pathname === "/sports" ||
    props.location.pathname === "/sports-details" ||
    props.location.pathname === "/league-details";
  // Real live-match count for the sub-bar's Live badge — same /v4/live/info
  // endpoint HomeUpcoming.jsx already polls for its own live-sport list.
  const [liveCount, setLiveCount] = useState(0);
  useEffect(() => {
    getLiveSportsCall()
      .then((res) => {
        const total = (res?.data?.data ?? []).reduce(
          (sum, sport) => sum + (sport?.live ?? 0),
          0,
        );
        setLiveCount(total);
      })
      .catch(() => {});
  }, []);
  // The Popular/Banner/Instant-Registration block below used to render
  // directly under the header, full-width, before AppLayout's rail|content|
  // betslip grid even starts — so on desktop it never lined up with the new
  // sport rail (rail starts inside the grid; this started above it). Portal
  // it into a slot AppLayout renders as the first child of the content
  // column instead, so it's a real sibling of the rail/betslip and starts at
  // the same y — without touching any of this block's own state/logic.
  const [heroSlot, setHeroSlot] = useState(null);
  useEffect(() => {
    setHeroSlot(document.getElementById("sports-hero-slot"));
  }, [props.location.pathname]);
  const [userBalance, setUserBalance] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const currencySymbol = "₦";

  // getUserBalance() returns a display-ready string like "NGN 15000" (currency
  // prefix baked in, no thousands separator) — strip it back down to a raw
  // number so this component can format it consistently (RN parity).
  const parseRawBalance = (balance) =>
    parseFloat(String(balance ?? "0").replace(/[^\d.]/g, "")) || 0;

  // Run once when component mounts
  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const balance = await getUserBalance();
        setUserBalance(parseRawBalance(balance));
      } catch (err) {
        toastr.error(t("header_balance_fetch_error", "Could not fetch balance"));
      }
    };

    fetchBalance();
  }, []);

  // Handle manual refresh
  const handleRefreshBalance = async () => {
    try {
      setIsRefreshing(true); // start spinning
      const balance = await getUserBalance();
      setUserBalance(parseRawBalance(balance));

      // ⏳ Add small delay so spin animation is visible
      setTimeout(() => setIsRefreshing(false), 800);
    } catch (err) {
      toastr.error(t("header_balance_refresh_error", "Could not refresh balance"));
      setIsRefreshing(false);
    }
  };
  const successGetGameUrl = (res) => {
    setIframeURL(decodeURIComponent(res));
  };

  const errorGetGameUrl = (error) => {
    console.error("Error fetching game URL:", error);
  };

  const handleGameClick = (game) => {
    getSlotegratorGameCall(game, successGetGameUrl, errorGetGameUrl);
  };

  /* Sync the in-flow spacer height to the actual fixed header height.
     useLayoutEffect + double-rAF waits for the chips row to collapse to its
     final single-line height before measuring, so the spacer is accurate.
     ResizeObserver catches subsequent changes (chips appear/disappear). */
  const fixedHeaderRef = useRef(null);
  const spacerRef = useRef(null);
  useLayoutEffect(() => {
    const fixed = fixedHeaderRef.current;
    const spacer = spacerRef.current;
    if (!fixed || !spacer) return;
    const sync = () => {
      if (window.innerWidth < 768) {
        spacer.style.paddingTop = `${fixed.offsetHeight}px`;
      }
    };
    // Double rAF: wait two frames so the chips row finishes collapsing to
    // its final overflow-x:auto single-line height before we snapshot it.
    let f1 = requestAnimationFrame(() => {
      let f2 = requestAnimationFrame(sync);
      return f2;
    });
    const ro = new ResizeObserver(sync);
    ro.observe(fixed);
    return () => { cancelAnimationFrame(f1); ro.disconnect(); };
  }, []);

  return (
    <div>
      {/* Spacer height is set dynamically by ResizeObserver (see above).
          Desktop fallback via md: class. */}
      <div ref={spacerRef} className="BLM-layout-header md:pt-[calc(var(--topbar-h)+44px)]">
        <div
          ref={fixedHeaderRef}
          className={`w-full transition-all duration-300 fixed top-0 left-0 right-0 z-50 ${isSticky ? "shadow-md" : ""} ${isPathExcluded ? "hidden md:block" : ""}`}
        >
          {/* Background + max-w constraint applied here so the dark fill
              does not bleed beyond 1440px on wide screens. */}
          <div
            className="flex flex-col max-md:gap-0 max-w-[1440px] mx-auto w-full lg:px-3"
            style={{ background: "#0b131c", backdropFilter: "var(--blur-nav)" }}
          >
            <div className="BLM-mainHeader md:!justify-between max-md:flex max-md:justify-between max-md:items-center max-md:!bg-[var(--bg-canvas)] max-md:!min-h-14 max-md:!py-2 max-md:!px-3 max-md:border-b max-md:border-[var(--border-subtle)] md:!bg-transparent md:!h-[var(--topbar-h)] md:!px-6 lg:!px-4 ">
              <div className="BLM-mainHeader-leftSection max-md:flex max-md:items-center max-md:gap-3">
                {/* Hamburger: desktop always, mobile only when signed in */}
                <div
                  className={`hamburger_menu${isLoggedIn ? " lg:hidden" : " hidden md:block"}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(showSideBar(true));
                  }}
                >
                  <span className="md:hidden inline-flex">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <rect
                        width="32"
                        height="32"
                        rx="16"
                        fill="white"
                        fillOpacity="0.08"
                      />
                      <path
                        d="M10 12H22M10 16H22M10 20H22"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="hidden md:inline-flex">
                    <Hamburger />
                  </span>
                </div>
                <div
                  className="BLM-mainHeader-logo BLM-logo"
                  onClick={() => {
                    dispatch(setActiveTab("home-upcoming"));
                    dispatch(setActiveFooterTab("home"));
                    props.history.push("/sports");
                  }}
                >
                  {/* Mobile: Logo mark only at 26px height — matches design AppHeader spec */}
                  <div className="md:hidden flex items-center">
                    <img
                      src={brand.assets.logo}
                      className="BLM-logo-mobile h-[26px] w-auto object-contain"
                      alt={brand.name}
                    />
                  </div>
                  <div className="hidden md:flex items-center gap-1.5">
                    <img
                      src={brand.assets.logo}
                      className="BLM-logo-desktop"
                      alt={brand.name}
                    />
                  </div>
                </div>
              </div>
              {/* Desktop nav moved to its own bar below — see after BLM-mainHeader */}
              <div className="BLM-mainHeader-rightSection flex items-center gap-3 lg:ml-12">
                <div className="BLM-mainHeader-beforeLogin ">
                  <div className="BLM-mainHeader-loginRegister">
                    {isLoggedIn ? (
                      <div className="hidden md:flex items-center justify-between gap-4">
                        {/* Balance + icons group */}
                        <div className="flex items-center gap-2">
                          <Link to="/payment" className="flex flex-col items-start leading-tight">
                            <span
                              className="text-[10px] font-semibold tracking-[0.10em] uppercase"
                              style={{ color: "var(--text-muted)" }}
                            >
                              <Trans i18nKey="header_balance">Balance</Trans>
                            </span>
                            <span
                              className="BLM-betSlip-userBalance min-w-[4ch]"
                              style={{ fontFamily: "var(--font-numeric)", fontVariantNumeric: "tabular-nums" }}
                              id="betslipUserBalance"
                            >
                            {[
                              "home",
                              "sports",
                              "sports-details",
                              "jackpot",
                              "virtual-league",
                              "Games",
                              "Spribe",
                              "Slot",
                              "Bigwins",
                              "casinos",
                              "MyBets",
                              "Deposits",
                              "promotions",
                              "AllSports",
                              "withdrawals",
                              "mybets",
                              "sports-details",
                              "league-details",
                              "transaction-history",
                              "refer-a-friend",
                              "payment-error",
                              "payment-success",
                            ].includes(path)
                              ? showBalance
                                ? `${currency} ${userBalance.toLocaleString()}`
                                : `${currency} ${"•".repeat(String(Math.trunc(userBalance)).length || 4)}`
                              : null}
                            </span>
                          </Link>

                          {/* Refresh + Eye icons — after balance */}
                          <IconButton
                            icon={RefreshCwIcon}
                            label={t("header_refresh_balance", "Refresh balance")}
                            onClick={handleRefreshBalance}
                            className={`!text-[var(--bet-secondary)] ${isRefreshing ? "animate-spin-slow" : ""}`}
                          />
                          <IconButton
                            icon={showBalance ? Eye : EyeOff}
                            label={
                              showBalance
                                ? t("header_hide_balance", "Hide balance")
                                : t("header_show_balance", "Show balance")
                            }
                            onClick={toggleBalance}
                            className="!text-[var(--bet-white)]"
                          />
                        </div>

                        <Link to="/payment">
                          <Button variant="primary" size="sm" className="gap-1">
                            <Plus className="h-4 w-4" />
                            <Trans i18nKey="header_deposit">Deposit</Trans>
                          </Button>
                        </Link>

                        {/* Account dropdown */}
                        <AccountMenu
                          open={isOpen}
                          onOpenChange={setIsOpen}
                          items={[
                            { to: "/profile", label: t("header_account_info", "Account Info"), icon: <User size={16} /> },
                            { to: "/payment", label: t("header_deposit", "Deposit"), icon: <CreditCard size={16} /> },
                            { to: "/payment?tab=withdraw", label: t("header_withdrawals", "Withdrawals"), icon: <NairaIcon size={16} /> },
                            { to: "/mybets", label: t("header_my_bets", "My Bets"), icon: <History size={16} /> },
                            { to: "/transaction-history", label: t("header_transaction_history", "Transaction History"), icon: <History size={16} /> },
                            { to: "/bonuses-awarded", label: t("header_my_bonuses", "My Bonuses"), icon: <Gem size={16} /> },
                            { to: "/refer-a-friend", label: t("header_refer_a_friend", "Refer A Friend"), icon: <Gift size={16} /> },
                          ].map((item) => {
                            const isDeposit = item.to === "/payment";
                            const isWithdraw = item.to === "/payment?tab=withdraw";
                            let active = props.location.pathname === item.to;
                            if (isDeposit) {
                              active = props.location.pathname === "/payment" && !props.location.search.includes("tab=withdraw");
                            } else if (isWithdraw) {
                              active = props.location.pathname === "/payment" && props.location.search.includes("tab=withdraw");
                            }
                            return { ...item, active };
                          }).concat([
                            { label: t("header_logout", "Logout"), icon: <LogOut size={16} />, onClick: handleLogout },
                          ])}
                        />

                        {/* Download app — logged-in desktop, mirrors logged-out placement */}
                        <a
                          href="/download"
                          className="hidden lg:flex items-center gap-1.5 text-sm !text-[var(--text-secondary)] hover:!text-white transition-colors"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                          </svg>
                          <Trans i18nKey="header_download_app">Download app</Trans>
                        </a>
                      </div>
                    ) : (
                      <>
                        {!isPathExcluded && (
                          <div className="flex items-center gap-3">
                            {/* Mobile: single login pill → full login screen */}
                            <Link to="/login" className="lg:hidden">
                              <button className="!bg-[#0b131c] !text-white !font-extrabold tracking-[0.4px] text-sm px-[18px] py-[9px] !rounded-full shadow-md truncate">
                                <Trans i18nKey="header_login">Login</Trans>
                              </button>
                            </Link>

                            {/* Desktop: LOGIN + JOIN NOW + Download app */}
                            <div className="hidden lg:flex items-center gap-4">
                              <Link
                                to="/login"
                                className="text-sm !font-semibold !uppercase tracking-[0.08em] !text-white hover:!text-[var(--bet-header-accent)] transition-colors whitespace-nowrap"
                              >
                                <Trans i18nKey="header_login">Login</Trans>
                              </Link>
                              <Link to="/register">
                                <button className="!bg-[var(--bet-header-accent)] !text-[#0d0e11] !font-bold text-sm !uppercase tracking-[0.05em] px-5 py-[10px] !rounded-[6px] hover:brightness-110 transition-all cursor-pointer truncate">
                                  <Trans i18nKey="header_join_now">Join Now</Trans>
                                </button>
                              </Link>
                              <a
                                href="/download"
                                className="flex items-center gap-1.5 text-sm !text-[var(--text-secondary)] hover:!text-white transition-colors whitespace-nowrap"
                              >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                  <polyline points="7 10 12 15 17 10" />
                                  <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                <Trans i18nKey="header_download_app">Download app</Trans>
                              </a>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {/* Theme toggle hidden — design decision: not exposed in mobile header */}
                {isLoggedIn && (
                  /* Mobile-only: wallet pill with the language selector stacked
                     directly under it (desktop keeps the selector up in its
                     usual spot instead, see above). */
                  <div className="flex md:hidden flex-col items-end gap-1.5">
                    {/* RN HomeHeader BalancePill (design spec): gold pill, white balance text, dark "+" button */}
                    <button
                      className="flex items-center gap-1.5 !bg-[var(--gold-500)] !rounded-full pl-2.5 pr-1 py-[5px]"
                      onClick={() => props.history.push(`/payment?tab=deposit`)}
                      aria-label={`${t("header_wallet_balance_aria", "Wallet balance")} ${userBalance}. ${t("header_tap_to_deposit_aria", "Tap to deposit.")}`}
                    >
                      <span className="flex items-center gap-1">
                        <span className="text-[var(--on-brand)] text-[13px] font-bold leading-none">
                          {currencySymbol}
                        </span>
                        <span className="text-[var(--on-brand)] text-[13px] font-bold leading-none">
                          {showBalance
                            ? userBalance.toLocaleString()
                            : "•".repeat(String(Math.trunc(userBalance)).length || 4)}
                        </span>
                      </span>
                      <svg width="26" height="26" viewBox="0 0 16 16" fill="none">
                        <rect width="16" height="16" rx="8" fill="var(--ink-950,#0b131c)" />
                        <path
                          d="M7.99998 5.08325V10.9166M5.08331 7.99992H10.9166"
                          stroke="var(--gold-500)"
                          strokeWidth="1.04167"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </div>
            {/*<div className="BLM-depositMpesa-header">*/}
            {/*  Deposit*/}
            {/*  <div className="BLM-iconSvg">*/}
            {/*    <svg*/}
            {/*      version="1.1"*/}
            {/*      baseProfile="tiny"*/}
            {/*      id="Layer_1"*/}
            {/*      xmlns="http://www.w3.org/2000/svg"*/}
            {/*      xmlnsXlink="http://www.w3.org/1999/xlink"*/}
            {/*      x="0px"*/}
            {/*      y="0px"*/}
            {/*      width="24px"*/}
            {/*      height="24px"*/}
            {/*      viewBox="0 0 24 24"*/}
            {/*      xmlSpace="preserve"*/}
            {/*    >*/}
            {/*      <path d="M13.6,1.6l-1.8,1.8l7.3,7.3H0v2.6h19l-7.3,7.3l1.8,1.8L24,12L13.6,1.6z" />*/}
            {/*    </svg>*/}
            {/*  </div>{" "}*/}
            {/*  MPESA Paybill: 238844*/}
            {/*</div>*/}
            {/* Mobile-only scrollable nav pill row (shown on /sports only) */}
            {Products.length > 0 && props.location.pathname === "/sports" && (
              <MemoizedHeaderNav
                Products={Products}
                dataMenu={dataMenu}
                isAvaitor={handleGameClick}
                hideMobile={active_tab === "home-live-now"}
                showDesktop={false}
              />
            )}

            {/* Desktop nav bar — inside max-w-[1440px] container so its
                background stays within the 1440px constraint.
                lg:-mx-3 cancels the container's lg:px-3 padding so the nav
                fills the full container width edge-to-edge. */}
            {Products.length > 0 && (
              <div className="hidden md:block lg:-mx-3">
                <MemoizedHeaderNav
                  Products={Products}
                  dataMenu={dataMenu}
                  isAvaitor={handleGameClick}
                  showMobile={false}
                />
              </div>
            )}
          </div>
        </div>
        {/* <div className="flex items-end justify-center relative max-h-[200px] overflow-hidden lg:hidden">

        <Banners Banner={Banner} />
      </div> */}
        {showSportsSubbar && (
          <div
            className="hidden items-center gap-3 overflow-x-auto px-3 lg:px-9 md:flex"
            style={{ height: "var(--subbar-h,44px)", background: "var(--bg-canvas)", borderBottom: "1px solid var(--border-subtle)" }}
          >
            <Badge tone="live">
              <Trans i18nKey="header_live">Live</Trans> {liveCount}
            </Badge>
            {["today", "tomorrow", "weekend"].map((id) => (
              <Tag
                key={id}
                selected={dayFilter === id}
                onClick={() => handleDayFilterClick(id)}
              >
                {
                  {
                    today: t("header_day_today", "Today"),
                    tomorrow: t("header_day_tomorrow", "Tomorrow"),
                    weekend: t("header_day_weekend", "Weekend"),
                  }[id]
                }
              </Tag>
            ))}
            <button
              type="button"
              onClick={() => {
                const params = new URLSearchParams(props.location.search);
                const sDate = params.get("start_date");
                const eDate = params.get("end_date");
                if (sDate && eDate) {
                  setTempStartDate(sDate.split("T")[0]);
                  setTempEndDate(eDate.split("T")[0]);
                } else {
                  setTempStartDate("");
                  setTempEndDate("");
                }
                setIsDateModalOpen(true);
              }}
              className={`inline-flex h-[30px] shrink-0 items-center gap-1.5 !rounded-full !border px-3 text-sm font-medium whitespace-nowrap transition-colors
                ${dayFilter === "custom"
                  ? "bg-[var(--bet-header-accent)] text-black !border-[var(--bet-header-accent)] font-semibold"
                  : "!border-[var(--border-subtle)] bg-[var(--surface-2)] text-[var(--text-secondary)] hover:!border-[var(--border-default)] hover:bg-[var(--surface-3)] hover:text-[var(--text-primary)]"
                }`}
            >
              <Calendar className="h-3.5 w-3.5" />
              <Trans i18nKey="header_custom_range">Custom range</Trans>
            </button>
            <div className="flex-1" />
            <span className="whitespace-nowrap text-xs text-[var(--text-muted)]">
              <Trans i18nKey="header_decimal_odds">Decimal odds</Trans>
            </span>
          </div>
        )}
        {props.location.pathname === "/sports" && heroSlot && createPortal(
          <>
            {/* Mobile-web quick-access football chips removed — duplicated TodayActionRow
                already rendered below the banner in Home.jsx's mobile tree */}
            {!isPathExcluded && (
              <Layout>
                <div className={"md:flex flex-col gap-1 w-full hidden md:pt-10"}>
                  <div
                    className={`flex flex-col sm:flex-row gap-4 items-center sm:items-stretch justify-center h-fit w-full ${isLoggedIn ? "lg:justify-center" : "lg:justify-start"
                      }`}
                  >
                    <div className={"hidden lg:flex"}>
                      <MemoizedPopularSports
                        title={t("header_popular_title", "Popular")}
                        items={[
                          {
                            title: t("header_popular_todays_football", "Today’s Football"),
                            link: `/sports-details?id=${SPORT_IDS.soccer}&tab=AllGames&quickFilter=today&day=today`,
                          },
                          {
                            title: t("header_popular_premier_league", "Premier League"),
                            link: "/league-details?sport_id=1&id=17",
                          },
                          {
                            title: t("header_popular_la_liga", "La Liga"),
                            link: "/league-details?sport_id=1&id=8",
                          },
                          {
                            title: t("header_popular_bundesliga", "Bundesliga"),
                            link: "/league-details?sport_id=1&id=35",
                          },
                          {
                            title: t("header_popular_serie_a", "Serie A"),
                            link: "/league-details?sport_id=1&id=23",
                          },
                        ]}
                      />
                    </div>
                    <div className={Banner?.length ? "lg:flex-1 lg:min-w-0 sm:w-full lg:flex items-end justify-center relative h-[280px] overflow-hidden !border !border-[var(--border-subtle)] rounded-[var(--radius-card)] bg-[var(--surface-card)] shadow-[var(--shadow-1)]" : "lg:flex-1 lg:min-w-0 sm:w-full lg:flex relative"}>
                      {/* <img
                  src="/assets/images/banners/heroBanner.png"
                  alt="hero-banner"
                  className="rounded-md object-cover"
                /> */}
                      {/* <div className="w-full overflow-hidden"> */}

                      <Banners Banner={Banner} />

                      {/* </div> */}
                    </div>
                  </div>
                  {/* <div className="w-full flex h-auto hidden ">
                  <img
                    src="/assets/images/banners/leaderboard.png"
                    alt="Imageboard"
                    className="rounded-md object-cover"
                  />
                </div> */}
                </div>

                <div className="BLM-sportsHeader BLM-scrollableArea BLM-horizontal !hidden !md:flex">
                  <div
                    className="BLM-categoryListItem BLM-inPlay"
                    // onClick="highlightFooterTab(event,this.getAttribute('data-footer-inplay')); getInplay('Football');"
                    data-footer-inplay="In-play"
                  >
                    {/*<div className="BLM-iconSvg">*/}
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 24 24"
                      style={{
                        enableBackground: "new 0 0 24 24",
                      }}
                      xmlSpace="preserve"
                    >
                      <path
                        d="M14.8,10.6l-5,3.3c-0.2,0.2-0.6,0-0.6-0.3V7c0-0.3,0.3-0.5,0.6-0.3l5,3.3C15,10.1,15,10.4,14.8,10.6z M22.6,4.8H1.4v10.9
                                                            h21.2V4.8 M22.7,3.4C23.4,3.4,24,4,24,4.7v11.1c0,0.7-0.6,1.3-1.3,1.3H1.3c-0.7,0-1.3-0.6-1.3-1.3V4.7C0,4,0.6,3.4,1.3,3.4H22.7
                                                            L22.7,3.4z M18,20v-0.5c0-0.3-0.3-0.6-0.6-0.6H6.6c-0.3,0-0.6,0.3-0.6,0.6V20c0,0.3,0.3,0.6,0.6,0.6h10.8C17.7,20.6,18,20.3,18,20z
                                                            "
                      />
                    </svg>
                    {/*</div>{" "}*/}
                    {/*Live Now*/}
                  </div>
                  {Sports?.data?.map((sport, index) => (
                    <>
                      <div
                        className="BLM-categoryListItem"
                        value="australian rules"
                        onClick={(e) => {
                          props.history.push(`/sports-details?id=${sport.id}`);
                          // window.location.href=`/sports-details?id=${sport.id}`;
                        }}
                        key={index + 1}
                      >
                        {/* sports icons below */}
                        {/* <img
                className="live-sports-img"
                src={`assets/images/sporticons/${getLiveSportImgName(
                  sport?.name
                )}.svg`}
              /> */}
                        {/*<i className={`sb-icon_sport-${getSportName(sport?.name)}`} />*/}
                        {/*{sport?.name}*/}
                      </div>
                    </>
                  ))}
                </div>
              </Layout>
            )}
          </>,
          heroSlot
        )}
      </div>
      <ReactModal
        style={customStyles}
        isOpen={!!iframeURL}
        onRequestClose={() => setIframeURL(null)}
        className="Casino_Games py-4"
      >
        <Iframe
          url={iframeURL}
          className="myClassname casino_game_iframe"
          display="initial"
          position="relative"
        />
      </ReactModal>

      <ReactModal
        style={dateModalStyles}
        isOpen={isDateModalOpen}
        onRequestClose={() => setIsDateModalOpen(false)}
        className="DateRangeModal"
      >
        <div className="text-white">
          {/* Modal Header */}
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-2">
              <Calendar className="h-[18px] w-[18px] text-[var(--bet-header-accent)]" />
              <span className="text-base font-semibold tracking-wide truncate">
                <Trans i18nKey="header_select_date_range">Select date range</Trans>
              </span>
            </div>
            <button
              onClick={() => setIsDateModalOpen(false)}
              className="text-gray-400 hover:text-white transition-colors focus:outline-none"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Modal Content - Date Inputs */}
          <div className="flex items-center gap-3 w-full mb-6">
            <div className="relative flex-1">
              <input
                type="date"
                value={tempStartDate}
                onChange={(e) => setTempStartDate(e.target.value)}
                className="w-full bg-[#0b131c] text-white border border-[#252838] rounded-lg py-2 px-3 text-sm focus:outline-none focus:border-[var(--bet-header-accent)] transition-colors"
                style={{ colorScheme: "dark" }}
              />
            </div>
            <ArrowRight className="text-gray-400 shrink-0" size={16} />
            <div className="relative flex-1">
              <input
                type="date"
                value={tempEndDate}
                onChange={(e) => setTempEndDate(e.target.value)}
                className="w-full bg-[#0b131c] text-white border border-[#252838] rounded-lg py-2 px-3 text-sm focus:outline-none focus:border-[var(--bet-header-accent)] transition-colors"
                style={{ colorScheme: "dark" }}
              />
            </div>
          </div>

          {/* Modal Footer - Actions */}
          <div className="flex justify-end items-center gap-4 mt-6">
            <button
              type="button"
              onClick={handleClearDates}
              className="text-xs font-semibold uppercase tracking-wider text-gray-400 hover:text-white transition-colors py-2 px-4 focus:outline-none whitespace-nowrap"
            >
              <Trans i18nKey="header_clear_dates">Clear</Trans>
            </button>
            <button
              type="button"
              onClick={handleApplyDates}
              className="bg-[var(--bet-header-accent)] text-black text-xs font-bold uppercase tracking-wider py-2.5 px-6 rounded-md hover:opacity-90 transition-opacity focus:outline-none whitespace-nowrap"
            >
              <Trans i18nKey="header_apply_dates">Apply</Trans>
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default withRouter(Header);
